import { useState, useRef, useEffect } from 'react'

export function useMermaid() {
  const mermaidRef = useRef(null)
  const [ready, setReady] = useState(false)

  useEffect(() => {
    import('mermaid').then(m => {
      m.default.initialize({
        startOnLoad: false,
        theme: 'dark',
        themeVariables: {
          darkMode: true,
          background: '#18181b',
          primaryColor: '#34d399',
          primaryTextColor: '#f4f4f5',
          lineColor: '#3f3f46',
          secondaryColor: '#27272a',
          tertiaryColor: '#27272a',
        },
      })
      mermaidRef.current = m.default
      setReady(true)
    })
  }, [])

  return { mermaid: mermaidRef, ready }
}
